import { type Store as StoreBase, storeCreate as storeCreateBase } from '@subaio/utils'
import { type ContainerState, ContainerStatus } from '@subaio/webapp/src/containers'

export type UserAuth =
	| { status: 'authenticated'; token: string; brandId: string; expiration: number; userId: string; budgetId: string }
	| { status: 'unauthenticated' }
	| { status: 'expired' }
export type UserAuthStatus = UserAuth['status']

export type State = ContainerState & {
	userAuth: UserAuth
}
export type Store = StoreBase<State>

export const defaultState: State = {
	page: { name: 'NotFound' },
	status: ContainerStatus.Running,

	userAuth: { status: 'unauthenticated' },
	data: {},
}

export const storeCreate = () => storeCreateBase<State>(defaultState)

export const expireSession = (store: Store) => {
	const { page } = store.getState()
	store.set({
		userAuth: { status: 'expired' },
		...(page.name === 'Flow' && {
			// A new page reference cancels initialization and updates from the expired session.
			page: { ...page },
			status: ContainerStatus.Initializing,
			data: {},
		}),
	})
}
